import React, { useEffect, useState } from 'react'
import { ContainerAdjuvante } from './styles'
import ViewPage from '../../../../Components/ViewPage'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import { Drawer } from 'antd'
import ButtonCustom from '../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons'
import { TabelaAdjuvantes } from './components/tabela'
import { NavegacaoDrawer } from '../novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import { FormularioAdjuvantes } from './components/formulario'
import { AxiosResponse } from 'axios'
import { getRecomendaAtivos, TypeRecomendaAtivos } from '../../../../services/recomendacao/ativos'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'
import { putInsumos } from '../../../../services/recomendacao/insumos'
import { v4 as uid } from 'uuid'
import {
  getCategoriaInsumo,
  getCategoriaProdutos,
  getPropriedadeCalda,
  TypeCategoriaProdutos,
} from '../../../../services/categoriaProdutos'
import { getCategoriaMarcaInsumo } from '../../../../services/config/marca'
import { getFormulacao, TypeFormulacao } from '../../../../services/recomendacao/formulacao'
import { listMedidas, tiposGerais } from '../../../../services/Afins'
import {
  dadosAcao,
  filtrarPropriedades,
  filtrarPropriedadesEditar,
  verificarPropriedadesRemover,
} from './meta'
import { useGetAdjuvantes, useGetAdjuvantesEditar } from '../../../../services/adjuvantes/GET'
import { usePutRemoverDose } from '../../../../services/adjuvantes/PUT'
import { usePostAdjuvante, usePutAdjuvante } from '../../../../services/adjuvantes/POST'
import { useDeleteAdjuvantes } from '../../../../services/adjuvantes/DELETE'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'

interface TypeInsetAtivos {
  uid: string
  cod: number
  cod_ativo: number
  editable?: boolean
  nomeAtivo: string
  concentracao: number
}

const CadastroAdjuvante: React.FC = () => {
  //TABELA
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [buscarTabela, setBuscarTabela] = useState('')
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()

  const [fake_loading_tabela, setFake_loading_tabela] = useState<boolean>(false)

  //FORMULARIO
  const [update, setUpdate] = useState<number>(null)
  const [updateDuplicar, setUpdateDuplicar] = useState<number>(null)
  const [tab_selecionar_atual, setTab_selecionar_atual] = useState<
    'Dados do adjuvante' | 'Composição' | 'Propriedades' | 'Dose cultura'
  >('Dados do adjuvante')
  const [openForm, setOpenForm] = useState<boolean>(false)
  const [nome, setNome] = useState('')
  const [categoria, setCategoria] = useState<string>('')
  const [categoriaId, setCategoriaId] = useState<number>(null)
  const [classeAgro, setClasseAgro] = useState<string>('')
  const [classeAgroId, setClasseAgroId] = useState<number>(null)
  const [fabricante, setFabricante] = useState<string>('')
  const [fabricanteId, setFabricanteId] = useState<number>(null)
  const [formulacao, setFormulacao] = useState<string>('')
  const [formulacaoId, setFormulacaoId] = useState<number>(null)
  const [unidadeDose, setUnidadeDose] = useState<string>('')
  const [unidadeDoseId, setUnidadeDoseId] = useState<number>(null)
  const [observacao, setObservacao] = useState<string>('')
  const [ativo, setAtivo] = useState<string>('')
  const [ativosId, setAtivosId] = useState<number>(null)
  const [ativos, setAtivos] = useState<TypeInsetAtivos[]>([] as TypeInsetAtivos[])
  const [concentracao, setConcentracao] = useState<string>('')
  const [cultura, setCultura] = useState<string>('')
  const [culturaId, setCulturaId] = useState<number>(null)
  const [dataCatProduto, setDataCatProduto] = useState([])
  const [dataAtivos, setDataAtivos] = useState([])
  const [dataCatCategoria, setDataCatCategoria] = useState([])
  const [dataFabricantes, setDataFabricantes] = useState([])
  const [dataFormulacao, setDataFormulacao] = useState([])
  const [dataUnidadeMedida, setDataUnidadeMedida] = useState([])
  const [dataUnidadeMedidaComposicao, setDataUnidadeMedidaComposicao] = useState([])
  const [dataNaCalda, setDataNaCalda] = useState([])
  const [dataNaPlanta, setDataNaPlanta] = useState([])
  const [caldasSelecionadas, setCaldasSelecionadas] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [gotaSelecionadas, setGotaSelecionadas] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [folhaSelecionadas, setFolhaSelecionadas] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [dentroSelecionadas, setDentroSelecionadas] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [caldasSelecionadasEditar, setCaldasSelecionadasEditar] = useState([])
  const [gotaSelecionadasEditar, setGotaSelecionadasEditar] = useState([])
  const [folhaSelecionadasEditar, setFolhaSelecionadasEditar] = useState([])
  const [dentroSelecionadasEditar, setDentroSelecionadasEditar] = useState([])
  const [acaoPhSelecionada, setAcaoPhSelecionada] = useState<string>('')
  const [acaoPhSelecionadaId, setAcaoPhSelecionadaId] = useState<number>(null)
  const [dataCulturas, setDataCulturas] = useState([])
  const [valor_dose, setValor_dose] = useState<string>('')
  const [doses_culturas_adicionados, setDoses_culturas_adicionados] = useState([])
  const [medidaComposicao, setMedidaComposicao] = useState<string>('')
  const [medidadaComposicaoId, setMedidaComposicaoId] = useState<number>(null)
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  //API
  const { carregando_adjuvantes, data_adjuvantes, refetch_data_adjuvantes } = useGetAdjuvantes(
    pagination,
    page,
    buscarTabela
  )
  const { carregando_adjuvantes_editar, data_adjuvantes_editar, refetch_data_adjuvantes_editar } =
    useGetAdjuvantesEditar(update ?? updateDuplicar)
  const { carregando_remover_dose, mutate_remover_dose, isSuccess_remover_dose } =
    usePutRemoverDose()
  const { carregando_salvar_adjuvante, mutate_adjuvante } = usePostAdjuvante()
  const { carregando_salvar_adjuvante_editado, mutate_adjuvante_editado } = usePutAdjuvante(update)
  const { carregando_deletar_adjuvantes, mudateDeletarAdjuvantes } = useDeleteAdjuvantes()

  const listCatProduto = async () => {
    const resp: AxiosResponse<TypeCategoriaProdutos> = await getCategoriaProdutos({ codGrupo: 20, codCategoriaProduto: 2 })
    setDataCatProduto(resp.data.itens)
  }

  async function listCatInsumos() {
    const resp: AxiosResponse = await getCategoriaInsumo({})
    const filtro = resp.data.itens?.filter((item) =>
      [155, 156, 157, 158, 159, 204, 205].includes(item?.cod)
    )
    setDataCatCategoria(filtro)
  }

  const listCultura = async () => {
    const resp = await tiposGerais()

    setDataCulturas(resp)
  }

  async function listPropriedades() {
    const resp: AxiosResponse = await getPropriedadeCalda({})

    const calda = resp.data.itens.filter((item) => item?.cod_tipo_geral === 189)
    const planta = resp.data.itens.filter((item) => item?.cod_tipo_geral === 203)

    setDataNaCalda(calda)
    setDataNaPlanta(planta)
  }

  const listFabricantes = async () => {
    const resp = await getCategoriaMarcaInsumo()
    setDataFabricantes(resp.data.itens)
  }

  const listFormulacao = async () => {
    const resp: AxiosResponse<TypeFormulacao> = await getFormulacao({
      pagination: -1,
    })

    setDataFormulacao(resp.data.itens)
  }

  const listUnidadeMedida = async () => {
    const resp = await listMedidas()

    const filtro = resp?.filter((item) => [2, 10].includes(item?.cod))
    const filtroComposicao = resp?.filter((item) => [11, 10].includes(item?.cod))
    setDataUnidadeMedida(filtro)
    setDataUnidadeMedidaComposicao(filtroComposicao)
  }

  function duplicar(cod) {
    setOpenForm(true)
    setUpdateDuplicar(cod)
  }

  function abrirGaveta() {
    setOpenForm(true)
  }

  function editarAdjuvante(cod) {
    setUpdate(cod)
    setOpenForm(true)
  }

  function fecharGaveta() {
    setOpenForm(false)
    setUpdate(null)
    setUpdateDuplicar(null)
    setTab_selecionar_atual('Dados do adjuvante')
    setNome('')
    setCategoria('')
    setCategoriaId(null)
    setClasseAgro('')
    setClasseAgroId(null)
    setFabricante('')
    setFabricanteId(null)
    setFormulacao('')
    setFormulacaoId(null)
    setUnidadeDose('')
    setUnidadeDoseId(null)
    setObservacao('')
    setAtivo('')
    setAtivosId(null)
    setConcentracao('')
    setAtivos([])
    setCultura('')
    setCulturaId(null)
    setMedidaComposicao('')
    setAcaoPhSelecionada('')
    setAcaoPhSelecionadaId(null)
    setMedidaComposicaoId(0)
    setDoses_culturas_adicionados([])
    setCaldasSelecionadas([])
    setGotaSelecionadas([])
    setFolhaSelecionadas([])
    setDentroSelecionadas([])
    refetch_data_adjuvantes()
  }

  const handleChangeClasse = async (codCategoriaProduto) => {
    setClasseAgroId(codCategoriaProduto)
    const resp: AxiosResponse<TypeRecomendaAtivos> = await getRecomendaAtivos({
      codCategoriaProduto,
      pagination: -1,
    })

    const catego = dataCatProduto.find((data) => codCategoriaProduto === data.cod)
    if (catego?.cod_categoria === 10) {
    }

    setDataAtivos(resp.data.itens)
  }

  const adicionarCultura = async () => {
    const check = doses_culturas_adicionados.find((data) => data.cod_cultura === culturaId)

    if (check !== undefined) {
      errorAlert('Dose para cultura já inserido!')

      return
    }

    if (cultura === '' || culturaId === 0 || valor_dose === '') {
      errorAlert('Preencha todos os campos!')
    } else {
      setDoses_culturas_adicionados([
        ...doses_culturas_adicionados,
        {
          uid: uid(),
          cod: null,
          cod_cultura: culturaId,
          cultura_nome: cultura,
          dose: Number(valor_dose?.replace(',', '.')),
        },
      ])
    }

    setCultura('')
    setCulturaId(null)
    setValor_dose('')
  }

  const adicionarAtivos = async () => {
    const nomeAtivo = dataAtivos.find((data) => data.cod === ativosId)

    const check = ativos.find((data) => data.cod_ativo === ativosId)

    if (check !== undefined) {
      errorAlert('Ativo já inserido!')

      return
    }

    setAtivos([
      ...ativos,
      {
        uid: uid(),
        cod: null,
        cod_ativo: ativosId,
        nomeAtivo: nomeAtivo.nome,
        concentracao: Number(concentracao.replace(',', '.')),
      },
    ])
    setAtivo('')
    setConcentracao('')
  }

  const handleRemoveAtivo = async (uid, cod = null) => {
    setFake_loading(true)
    const dados = [...ativos]
    let filtro = []
    if (cod === null) {
      filtro = dados.filter((data) => data.uid !== uid)
      return setAtivos(filtro)
    } else {
      loadingAlert({ msg: 'Removendo...', id: 'remove_ativo' })
      mutate_remover_dose({
        cod: update,
        ativos_remover: [cod],
        refetch: refetch_data_adjuvantes,
      })

      if (isSuccess_remover_dose) {
        filtro = dados.filter((data) => data.uid !== uid)
        successAlert('Ativo removido com sucesso!', 5000, 'remove_ativo')
        setFake_loading(false)
        return setAtivos(filtro)
      } else {
        errorAlert('Falha na operação!', 5000, 'remove_ativo')
        setFake_loading(false)
        return setAtivos(dados)
      }
    }
  }

  const remover_cultura_dose = async (uid, cod = null, cod_cultura) => {
    const dados = [...doses_culturas_adicionados]
    let filtro = []
    if (cod === null) {
      filtro = dados.filter((data) => data.cod_cultura !== cod_cultura)
      setFake_loading(false)
      return setDoses_culturas_adicionados(filtro)
    } else {
      // loadingAlert({ msg: 'Removendo...', id: 'remover_cultura_dose' })
      mutate_remover_dose({
        cod: update,
        doses_remover: [cod_cultura],
        refetch: refetch_data_adjuvantes,
      })
      filtro = dados.filter((data) => data.cod_cultura !== cod_cultura)

      // successAlert('Cultura removido com sucesso!', 5000, 'remover_cultura_dose')
      setFake_loading(false)
      return setDoses_culturas_adicionados(filtro)
    }
  }

  function deletarAdjuvantes(cod) {
    setFake_loading_tabela(true)
    mudateDeletarAdjuvantes({
      cod_adjuvante: cod,
      refetch_deletar: () => refetch_data_adjuvantes(),
    })

    setTimeout(() => {
      setFake_loading_tabela(false)
    }, 800)
  }

  function salvarAdjuvante() {
    const ativosFormatado = ativos.map((item) => {
      return {
        cod_ativo: item?.cod_ativo,
        concentracao: item?.concentracao,
      }
    })
    const doseFormatado = doses_culturas_adicionados.map((item) => {
      return {
        cod_cultura: item?.cod_cultura,
        dose: item?.dose,
      }
    })

    const propriedades_remover = verificarPropriedadesRemover(
      caldasSelecionadasEditar,
      gotaSelecionadasEditar,
      caldasSelecionadas,
      gotaSelecionadas
    )

    const temPreenchido = Object.values(propriedades_remover).some(
      (arr) => Array.isArray(arr) && arr.length > 0
    )

    const propriedades = {
      calda: caldasSelecionadas?.map((item) => item.id),
      planta: gotaSelecionadas?.map((item) => item.id),
    }

    if (update <= 0 || updateDuplicar > 0) {
      mutate_adjuvante({
        nome: nome,
        descricao: observacao,
        cod_categoria_produto: classeAgroId,
        cod_fabricante: fabricanteId,
        cod_medida_aplicacao: unidadeDoseId,
        cod_medida_composicao: medidadaComposicaoId === 0 ? null : medidadaComposicaoId,
        //@ts-ignore
        ativos: ativosFormatado,
        propriedades: propriedades,
        acao_ph_calda: acaoPhSelecionadaId,
        doses: doseFormatado,
        refetch: fecharGaveta,
      })
    }

    if (update > 0) {
      if (temPreenchido) {
        mutate_remover_dose({
          cod: update,
          //@ts-ignore
          propriedades_remover: propriedades_remover,
          refetch: refetch_data_adjuvantes,
        })
      }
      mutate_adjuvante_editado({
        nome: nome,
        descricao: observacao,
        cod_categoria_produto: classeAgroId,
        cod_fabricante: fabricanteId,
        cod_medida_aplicacao: unidadeDoseId,
        cod_medida_composicao: medidadaComposicaoId === 0 ? null : medidadaComposicaoId,
        //@ts-ignore
        ativos: ativosFormatado,
        propriedades: propriedades,
        acao_ph_calda: acaoPhSelecionadaId,
        doses: doseFormatado,
        refetch: fecharGaveta,
      })
    }
  }

  useEffect(() => {
    if (data_adjuvantes_editar?.itens?.length > 0) {
      const filtradoAcaoPH = dadosAcao.filter(
        (item) => item.nome === data_adjuvantes_editar?.itens[0]?.acao_ph_calda
      )
      setNome(updateDuplicar > 0 ? '' : data_adjuvantes_editar?.itens[0]?.nome)
      setCategoria(data_adjuvantes_editar?.itens[0]?.categoria_produto_nome)
      setCategoriaId(data_adjuvantes_editar?.itens[0]?.cod_categoria_produto)
      setClasseAgro(data_adjuvantes_editar?.itens[0]?.categoria_produto_nome)
      setClasseAgroId(data_adjuvantes_editar?.itens[0]?.cod_categoria_produto)
      handleChangeClasse(data_adjuvantes_editar?.itens[0]?.cod_categoria_produto)
      setFabricante(data_adjuvantes_editar?.itens[0]?.fabricante_nome)
      setFabricanteId(data_adjuvantes_editar?.itens[0]?.cod_fabricante)
      setUnidadeDose(data_adjuvantes_editar?.itens[0]?.nome_medida_aplicacao)
      setUnidadeDoseId(data_adjuvantes_editar?.itens[0]?.cod_medida_aplicacao)
      setObservacao(data_adjuvantes_editar?.itens[0]?.descricao)
      let composicao = []
      data_adjuvantes_editar?.itens[0]?.composicao?.forEach((data) => {
        setMedidaComposicaoId(data?.cod_tipo_medida)
        setMedidaComposicao(data?.nome_tipo_medida)
        composicao = [
          ...composicao,
          {
            uid: uid(),
            cod: data.cod,
            concentracao: data.concentracao,
            cod_ativo: data.cod_ativo,
            nomeAtivo: data.ativo_nome,
          },
        ]
      })
      setAtivos(composicao)
      setDoses_culturas_adicionados(data_adjuvantes_editar?.itens[0]?.doses)
      setAcaoPhSelecionada(filtradoAcaoPH[0]?.nome)
      setAcaoPhSelecionadaId(filtradoAcaoPH[0]?.cod)
      filtrarPropriedades(
        setCaldasSelecionadas,
        setGotaSelecionadas,
        data_adjuvantes_editar?.itens[0]?.propriedades_adjuvante
      )
      filtrarPropriedadesEditar(
        setCaldasSelecionadasEditar,
        setGotaSelecionadasEditar,
        data_adjuvantes_editar?.itens[0]?.propriedades_adjuvante
      )
    }
  }, [data_adjuvantes_editar])

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        refetch_data_adjuvantes()
      }, 700)
    }
    if (buscarTabela === '') {
      refetch_data_adjuvantes()
    }
  }, [buscarTabela])

  useEffect(() => {
    if (update > 0) {
      refetch_data_adjuvantes_editar()
    }
  }, [update])

  useEffect(() => {
    if (updateDuplicar > 0) {
      refetch_data_adjuvantes_editar()
    }
  }, [updateDuplicar])

  useEffect(() => {
    refetch_data_adjuvantes()
  }, [pagination, page])

  useEffect(() => {
    refetch_data_adjuvantes()
    listCatProduto()
    listCatInsumos()
    listFormulacao()
    listFabricantes()
    listUnidadeMedida()
    listPropriedades()
    listCultura()
  }, [])

  return (
    <ContainerAdjuvante>
      <ViewPage
        title='Cadastro adjuvantes'
        onPermission={setPermissions}
        rotina={107}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
        newHide
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Cadastro adjuvantes</TitleH1>
        </div>
        <TabelaAdjuvantes
          loading={carregando_adjuvantes}
          list_adjuvantes={data_adjuvantes?.itens}
          deletar={deletarAdjuvantes}
          abrir={abrirGaveta}
          editar={editarAdjuvante}
          duplicar={duplicar}
          page={page}
          setPage={setPage}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          setPagination={setPagination}
          total={data_adjuvantes?.total}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading_tabela}
          setFake_loading={setFake_loading_tabela}
          permissions={permissions}
        />

        <Drawer
          width={800}
          open={openForm}
          onClose={fecharGaveta}
          closable={false}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: '10px 10px' }}
          destroyOnClose
          footer={
            <div className='footer'>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                type='primary'
                onClick={salvarAdjuvante}
                loading={carregando_salvar_adjuvante || carregando_salvar_adjuvante_editado}
                disabled={
                  carregando_adjuvantes ||
                  carregando_adjuvantes_editar ||
                  permissions?.alteracao === 0 ||
                  permissions?.inclusao === 0
                }
              >
                Salvar
              </ButtonCustom>
            </div>
          }
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={fecharGaveta}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
        >
          <FormularioAdjuvantes
            loading={carregando_adjuvantes_editar}
            update={update}
            tab_selecionar_atual={tab_selecionar_atual}
            setTab_selecionar_atual={setTab_selecionar_atual}
            nome={nome}
            setNome={setNome}
            categoria_insumo={categoria}
            setCategoria_insumo={setCategoria}
            categoria_insumoId={categoriaId}
            setCategoria_insumoId={setCategoriaId}
            classeAgro={classeAgro}
            setClasseAgro={setClasseAgro}
            classeAgroId={classeAgroId}
            setClasseAgroId={setClasseAgroId}
            fabricante={fabricante}
            setFabricante={setFabricante}
            fabricanteId={fabricanteId}
            setFabricanteId={setFabricanteId}
            formulacao={formulacao}
            setFormulacao={setFormulacao}
            formulacaoId={formulacaoId}
            setFormulacaoId={setFormulacaoId}
            unidadeDose={unidadeDose}
            setUnidadeDose={setUnidadeDose}
            unidadeDoseId={unidadeDoseId}
            setUnidadeDoseId={setUnidadeDoseId}
            unidadeComposicao={medidaComposicao}
            setUnidadeComposicao={setMedidaComposicao}
            setUnidadeComposicaoId={setMedidaComposicaoId}
            observacao={observacao}
            setObservacao={setObservacao}
            dataCatProduto={dataCatProduto}
            dataCatCategoria={dataCatCategoria}
            dataFabricantes={dataFabricantes}
            dataFormulacao={dataFormulacao}
            dataUnidadeMedida={dataUnidadeMedida}
            dataUnidadeMedidaComposicao={dataUnidadeMedidaComposicao}
            handleChangeClasse={handleChangeClasse}
            ativo={ativo}
            setAtivo={setAtivo}
            ativosId={ativosId}
            setAtivoId={setAtivosId}
            concentracao={concentracao}
            setConcentracao={setConcentracao}
            ativos={ativos}
            setAtivos={setAtivos}
            dataAtivos={dataAtivos}
            adicionarAtivos={adicionarAtivos}
            handleRemoveAtivo={handleRemoveAtivo}
            dataCaldas={dataNaCalda}
            dataPlantas={dataNaPlanta}
            caldasSelecionadas={caldasSelecionadas}
            setCaldasSelecionadas={setCaldasSelecionadas}
            acaoPhSelecionadas={acaoPhSelecionada}
            setAcaoPhSelecionadas={setAcaoPhSelecionada}
            setAcaoPhSelecionadasId={setAcaoPhSelecionadaId}
            dataCulturas={dataCulturas}
            cultura={cultura}
            setCultura={setCultura}
            setCulturaId={setCulturaId}
            valor_dose={valor_dose}
            setValor_dose={setValor_dose}
            doses_culturas_adicionados={doses_culturas_adicionados}
            setDoses_culturas_adicionados={setDoses_culturas_adicionados}
            adicionar_dose={adicionarCultura}
            remover_cultura_dose={remover_cultura_dose}
            gotaSelecionadas={gotaSelecionadas}
            setGotaSelecionadas={setGotaSelecionadas}
            folhaSelecionadas={folhaSelecionadas}
            setFolhaSelecionadas={setFolhaSelecionadas}
            dentroSelecionadas={dentroSelecionadas}
            setDentroSelecionadas={setDentroSelecionadas}
            fakeLoading={fake_loading}
          />
        </Drawer>
      </ViewPage>
    </ContainerAdjuvante>
  )
}

export default CadastroAdjuvante
